exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit_wrap[data-v-128d391c]{width:1050px;margin:50px auto;border:1px solid #eee}.edit_wrap .add_top[data-v-128d391c]{width:100%;height:40px;background-color:#f9f9f9}.edit_wrap .add_tab[data-v-128d391c]{display:inline-block;width:170px;height:40px;text-align:center;line-height:40px;color:#666;font-size:14px;cursor:pointer}.edit_wrap .active_tab[data-v-128d391c]{border-bottom:1px solid #ff4a7d;color:#ff4a7d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-128d391c","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/info_manage/add_categary_agree/addBrandCommonPages.vue
// module id = 351
// module chunks = 0